// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2KUnu","actions":"GroupTable_actions__e7fAc","deleteModalFooter":"GroupTable_deleteModalFooter__vh52L"};